import { AxiosError } from 'axios';
import { StatusCodes } from 'http-status-codes';
import { getApiErrorStatusCode } from '../axios/axios-api-error';

export const isNotValidVatNumberError = (error: AxiosError) =>
  getApiErrorStatusCode(error) === StatusCodes.BAD_REQUEST &&
  error.response?.data.message ===
    'The tax identification number is incorrect for the selected country.';
